import * as Yup from 'yup';
import type { AdvancePaymentPayload, RefundRequestPayload, } from './advance.interfaces';
import i18n from '../../../services/i18n';
export * from './advance.interfaces';
export * from './advance.urls';


const todayISO = new Date().toISOString().slice(0, 10);
export const advanceInitialValues:AdvancePaymentPayload = {
  advance_against: '',
  advance_type: 'CHECKIN',
  date: todayISO,
  amount: 0,
  remark: '',
  appointment_visit: 0,
  
};

const requiredMessage = () => i18n.t('Advance.validation.required', { ns: 'billing_config', defaultValue: 'Required' });
const amountGreaterThanZeroMessage = () => i18n.t('Advance.validation.amount_gt_zero', { ns: 'billing_config', defaultValue: 'Amount must be greater than zero' });
const amountExceedsPackageMessage = () => i18n.t('Advance.validation.amount_exceeds_package_balance', {
  ns: 'billing_config',
  defaultValue: 'Amount cannot exceed Package Net Amount - Package Paid Amount',
});
const amountPositiveMessage = () => i18n.t('Advance.validation.amount_positive', { ns: 'billing_config', defaultValue: 'Amount must be greater than 0' });
const amountExceedsRefundBalanceMessage = () => i18n.t('Advance.validation.amount_exceeds_refund_balance', {
  ns: 'billing_config',
  defaultValue: 'Amount exceeds available refund balance',
});

export const validationSchema = Yup.object({
  advance_against: Yup.string().required(requiredMessage),
  date: Yup.string().required(requiredMessage),
  amount: Yup.number()
    .min(1, amountGreaterThanZeroMessage)
    .when(['advance_type', 'balance_amount'], ([advance_type, balance_amount], schema: Yup.NumberSchema) => {
      if (advance_type === 'PACKAGE') {
        const maxVal = typeof balance_amount === 'number' ? balance_amount : 0;
        return schema.max(maxVal, amountExceedsPackageMessage);
      }
      return schema;
    })
    .required(requiredMessage),
  remark: Yup.string(),
});



export const RequestRefundinitialValues :RefundRequestPayload= {
  patient_id: 0,
  advance_type: '',
  advance_against: '',
  amount: null,
  totalAdvance: 0,
  advanceConsumed: 0,
  totalRefund: 0,
  advanceAvailableForRefund: 0,
  patient_package_id: null,
  remark: null,
  credit_transaction_id:null
};

export const RequestRefundvalidationSchema = Yup.object({
  patient_id: Yup.number().min(1).required(requiredMessage),
  amount: Yup.number()
    .required(requiredMessage)
    .positive(amountPositiveMessage)
    .test(
      'max-refund-amount',
      amountExceedsRefundBalanceMessage,
      function (value) {
        if (value === undefined || value === null || value <= 0) {
          return true; // Let required/positive validations handle these cases
        }
        const { advanceAvailableForRefund } = this.parent;
        const maxRefundable = advanceAvailableForRefund || 0;
        return value <= maxRefundable;
      }
    ),
  remark: Yup.string().nullable(),
  advance_type: Yup.string().required(requiredMessage),
  patient_package_id: Yup.mixed().when('advance_type', ([advance_type],) => {
    return advance_type === 'PACKAGE'
      ? Yup.number().typeError(requiredMessage).required(requiredMessage)
      : Yup.mixed().notRequired();
  }),
});


